/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';

/**
 * 
 * @export
 * @interface CreateExpenseRequest
 */
export interface CreateExpenseRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateExpenseRequest
     */
    occurredAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    amount: number;
    /**
     * 
     * @type {PaymentType}
     * @memberof CreateExpenseRequest
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    typeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    createdById?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExpenseRequest
     */
    attachmentIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExpenseRequest
     */
    tagIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateExpenseRequest interface.
 */
export function instanceOfCreateExpenseRequest(value: object): value is CreateExpenseRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function CreateExpenseRequestFromJSON(json: any): CreateExpenseRequest {
    return CreateExpenseRequestFromJSONTyped(json, false);
}

export function CreateExpenseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExpenseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'occurredAt': json['occurred_at'] == null ? undefined : (new Date(json['occurred_at'])),
        'amount': json['amount'],
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'name': json['name'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'projectId': json['projectId'],
        'typeId': json['typeId'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'attachmentIds': json['attachmentIds'] == null ? undefined : json['attachmentIds'],
        'tagIds': json['tagIds'] == null ? undefined : json['tagIds'],
    };
}

export function CreateExpenseRequestToJSON(json: any): CreateExpenseRequest {
    return CreateExpenseRequestToJSONTyped(json, false);
}

export function CreateExpenseRequestToJSONTyped(value?: CreateExpenseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occurred_at': value['occurredAt'] == null ? undefined : ((value['occurredAt']).toISOString()),
        'amount': value['amount'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'name': value['name'],
        'comments': value['comments'],
        'projectId': value['projectId'],
        'typeId': value['typeId'],
        'createdById': value['createdById'],
        'attachmentIds': value['attachmentIds'],
        'tagIds': value['tagIds'],
    };
}

